
$("body").on("click", ".editStatus", function () {
    // Get the modal and modal content elements
    var modal = new bootstrap.Modal(document.getElementById("modalChangeStatusModal"));
    var modalContent = $("#modalChangeStatus");

    let changesId = $(this).data("id");
    // Perform AJAX request to fetch content
    $.ajax({
        url: "api__loadModalChangeStatus?changesId=" + changesId, // Replace 'your_content_url' with the URL that returns the content you want to load.
        type: "GET",

        success: function (response) {
            // Update modal content with the fetched data
            modalContent.html(response);
            // Show the modal

            modal.show();
  

        },
        error: function () {
            modalContent.html("Error loading content.");
        },
    });
});

jQuery("body").on("custom__modalChangeStatus", function (e, a, b) {
    console.log("custom__modalChangeFinish....");
    console.log(a);
    console.log(b);
    changeTable.ajax.reload();
    $("#modalChangeImage").modal("hide");
});